<table #table mat-table [dataSource]="dataSource" matSort matSortDirection="asc" matSortActive="name"
       class="mat-elevation-z4">

  <ng-container matColumnDef="name">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>Ort</th>
    <td mat-cell *matCellDef="let element">{{element?.ort?.name}}</td>
    <td mat-footer-cell class="mat_footer" *matFooterCellDef>
      {{date | date: 'EE HH:mm yy'}}
      <button mat-button (click)="reloadData.emit()">
        <mat-icon class="boxed_icon">refresh</mat-icon>
      </button>
    </td>
  </ng-container>

  <ng-container matColumnDef="bundesland">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>Bundesland</th>
    <td mat-cell *matCellDef="let element">{{element?.ort?.bundesLand}}</td>
    <td mat-footer-cell *matFooterCellDef></td>
  </ng-container>

  <ng-container matColumnDef="lufttemperatur">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>Lufttemp.</th>
    <td mat-cell
        matTooltip="{{element.messwerte?.lufttemperatur?.messzeitpunkt.toDate() | date: 'dd.MM.yy HH:mm'}}"
        *matCellDef="let element">
      {{werteConverter.convertDecimalWithComma(element.messwerte?.lufttemperatur?.messwertAsText)}} {{element.messwerte?.lufttemperatur?.einheit}}
    </td>
    <td mat-footer-cell *matFooterCellDef></td>
  </ng-container>

  <ng-container matColumnDef="lufttemperaturBoden">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>Bodentemp.</th>
    <td mat-cell
        matTooltip="{{element.messwerte?.lufttemperaturBoden?.messzeitpunkt.toDate() | date: 'dd.MM.yy HH:mm'}}"
        *matCellDef="let element">
      {{werteConverter.convertDecimalWithComma(element.messwerte?.lufttemperaturBoden?.messwertAsText)}} {{element.messwerte?.lufttemperaturBoden?.einheit }}
    </td>
    <td mat-footer-cell *matFooterCellDef></td>
  </ng-container>

  <ng-container matColumnDef="niederschlagsmenge">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>Niederschlag</th>
    <td mat-cell
        matTooltip="{{element.messwerte?.niederschlagsMenge?.messzeitraum.von.toDate() | date: 'dd.MM.yy HH:mm'}} - {{element.messwerte?.niederschlagsMenge?.messzeitraum.bis.toDate() | date: 'dd.MM.yy HH:mm'}}"
        *matCellDef="let element">
      {{element.messwerte?.niederschlagsMenge?.messwertAsText}}  {{werteConverter.convertToQuadratmeter(element.messwerte?.niederschlagsMenge?.einheit)}}
    </td>
    <td mat-footer-cell *matFooterCellDef></td>
  </ng-container>

  <ng-container matColumnDef="windgeschwindigkeit">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>Windgeschwindigkeit</th>
    <td mat-cell
        matTooltip="{{element.messwerte?.mittlereWindgeschwindigkeit?.messzeitraum.von.toDate() | date: 'dd.MM.yy HH:mm'}} - {{element.messwerte?.mittlereWindgeschwindigkeit?.messzeitraum.bis.toDate() | date: 'dd.MM.yy HH:mm'}}"
        *matCellDef="let element">
      {{element.messwerte?.mittlereWindgeschwindigkeit?.messwertAsText}} {{ element.messwerte?.mittlereWindgeschwindigkeit?.einheit}}
    </td>
    <td mat-footer-cell *matFooterCellDef></td>
  </ng-container>

  <ng-container matColumnDef="windrichtung">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>Windrichtung</th>
    <td mat-cell
        matTooltip="{{element.messwerte?.mittlereWindrichtung?.messzeitraum.von.toDate() | date: 'dd.MM.yy HH:mm'}} - {{element.messwerte?.mittlereWindrichtung?.messzeitraum.bis.toDate() | date: 'dd.MM.yy HH:mm'}}"
        *matCellDef="let element">
      <mat-icon>{{werteConverter.getWindrichtungsIconByText(element.messwerte?.mittlereWindrichtung?.messwertAsText)}}</mat-icon>
      <mat-label class="table-icon-label">{{element.messwerte?.mittlereWindrichtung?.messwertAsText}}</mat-label>
    </td>
    <td mat-footer-cell *matFooterCellDef></td>
  </ng-container>

  <ng-container matColumnDef="feuchtigkeit">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>Feuchtigkeit</th>
    <td mat-cell
        matTooltip="{{element.messwerte?.relativeFeuchtigkeit?.messzeitpunkt.toDate() | date: 'dd.MM.yy HH:mm'}}"
        *matCellDef="let element">
      {{element.messwerte?.relativeFeuchtigkeit?.messwert}} {{element.messwerte?.relativeFeuchtigkeit?.einheit }}
    </td>
    <td mat-footer-cell *matFooterCellDef></td>
  </ng-container>

  <ng-container matColumnDef="taupunkt">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>Taupunkt</th>
    <td mat-cell
        matTooltip="{{element.messwerte?.taupunttemperatur?.messzeitpunkt.toDate() | date: 'dd.MM.yy HH:mm'}}"
        *matCellDef="let element">
      {{element.messwerte?.taupunttemperatur?.messwertAsText}} {{element.messwerte?.taupunttemperatur?.einheit }}
    </td>
    <td mat-footer-cell *matFooterCellDef></td>
  </ng-container>

  <ng-container matColumnDef="niederschlagsart">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>Niederschlagsart</th>
    <td mat-cell
        matTooltip="{{element.messwerte?.niederschalgsTyp?.messzeitpunkt.toDate() | date: 'dd.MM.yy HH:mm'}}"
        *matCellDef="let element">
      {{element.messwerte?.niederschalgsTyp?.messwertAsText}}
    </td>
    <td mat-footer-cell *matFooterCellDef></td>
  </ng-container>

  <ng-container matColumnDef="luftdruck">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>Luftdruck</th>
    <td mat-cell
        matTooltip="{{element.messwerte?.luftdruck?.messzeitpunkt.toDate() | date: 'dd.MM.yy HH:mm'}}"
        *matCellDef="let element">
      {{element.messwerte?.luftdruck?.messwertAsText}} {{element.messwerte?.luftdruck?.einheit}}
    </td>
    <td mat-footer-cell *matFooterCellDef></td>
  </ng-container>

  <ng-container matColumnDef="maxwindboee">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>Windboee</th>
    <td mat-cell
        matTooltip="{{element.messwerte?.maxWindboee?.messzeitraum.von.toDate() | date: 'dd.MM.yy HH:mm'}} - {{element.messwerte?.maxWindboee?.messzeitraum.bis.toDate() | date: 'dd.MM.yy HH:mm'}}"
        *matCellDef="let element">
      {{element.messwerte?.maxWindboee?.messwertAsText}} {{ element.messwerte?.maxWindboee?.einheit}}
    </td>
    <td mat-footer-cell *matFooterCellDef></td>
  </ng-container>

  <ng-container matColumnDef="horizontaleSichtweite">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>Sichtweite</th>
    <td mat-cell
        matTooltip="{{element.messwerte?.horizontaleSichtweite?.messzeitpunkt.toDate() | date: 'dd.MM.yy HH:mm'}}"
        *matCellDef="let element">
      {{element.messwerte?.horizontaleSichtweite?.messwert}} {{element.messwerte?.horizontaleSichtweite?.einheit }}
    </td>
    <td mat-footer-cell *matFooterCellDef></td>
  </ng-container>

  <ng-container matColumnDef="sonnenscheindauer">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>Sonnenscheindauer</th>
    <td mat-cell
        matTooltip="{{element.messwerte?.sonnenscheindauer?.messzeitraum.von.toDate() | date: 'dd.MM.yy HH:mm'}} - {{element.messwerte?.sonnenscheindauer?.messzeitraum.bis.toDate() | date: 'dd.MM.yy HH:mm'}} "
        *matCellDef="let element">
      {{element.messwerte?.sonnenscheindauer?.messwert * 60 | number: '1.0-0': 'de'}} min.
    </td>
    <td mat-footer-cell *matFooterCellDef></td>
  </ng-container>

  <ng-container matColumnDef="wetterzustand">
    <th mat-header-cell *matHeaderCellDef mat-sort-header> Wetterzustand</th>
    <td mat-cell *matCellDef="let element">{{element.messwerte?.wetterzustand?.messwertAsText}}</td>
    <td mat-footer-cell *matFooterCellDef></td>
  </ng-container>

  <ng-container matColumnDef="quelle">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>Quelle</th>
    <td mat-cell *matCellDef="let element">{{element.ort.quelle}}</td>
    <td mat-footer-cell *matFooterCellDef></td>
  </ng-container>

  <ng-container matColumnDef="typ">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>Typ</th>
    <td mat-cell *matCellDef="let element">{{element?.ort?.typ}}</td>
    <td mat-footer-cell *matFooterCellDef></td>
  </ng-container>

  <ng-container matColumnDef="id">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>ID</th>
    <td mat-cell *matCellDef="let element">{{element.ort.id}}</td>
    <td mat-footer-cell *matFooterCellDef></td>
  </ng-container>

  <tr mat-header-row *matHeaderRowDef="displayedColumns" sticky></tr>
  <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
  <tr mat-footer-row *matFooterRowDef="displayedColumns"></tr>

</table>

<mat-paginator (page)="scrollUp()" [pageSizeOptions]="[100,200,500,dataSource.data.length]"
               showFirstLastButtons></mat-paginator>
